import React from "react";

import './SidebarMenu.scss';

import {Nav} from "react-bootstrap";

import {useSessionUserContext} from "@ehcp/Contexts";
import {CalendarFill, DatabaseFillCheck, GearFill, Hourglass, HourglassSplit, HouseDoorFill, PencilFill, PieChartFill} from "react-bootstrap-icons";

import useUrlParamPersist from "root/DataFunctions/useUrlParamPersist";
import {urlParamNames} from "root/DataFunctions/useActiveTab";
import {MenuPermissions} from "@ehcp/MenuPermissions";
import SidebarMenuRenderer from "root/Components/Sidebar/SidebarMenuRenderer";
import {performGrouping, userMenuItems} from "root/Components/Sidebar/SidebarFunctions";

const SidebarMenu = () =>
{
    const { setValue : onMenuSelect, value : activeMenu } = useUrlParamPersist( urlParamNames.ACTIVE_MENU, 'home' ) ;

    const {user_type, hasRole, hasRolePermission } = useSessionUserContext();

    const menuItemList = [
        {
            keyName: 'home',
            text: 'Home',
            url: '/',
            icon: HouseDoorFill,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeeEHCPHomeMenu),
        },
        {
            keyName: 'admin',
            text: 'Administration',
            url: '/admin',
            icon: GearFill,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeeEHCPAdminMenu),
        },
        {
            keyName: 'panels',
            text: 'Panels',
            url: '/panels',
            icon: CalendarFill,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeeEHCPPanelsMenu),
        },
        {
            keyName: 'applications',
            text: 'COSA Applications',
            url: '/applications',
            icon: PencilFill,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeeCOSAApplicationsMenu),
        },
        /* { Stage removed at Dorothy's request and all actions from this stage moved up to the New Applications stage
            keyName: 'coordinatorqa',
            text: 'Co-ordinator QA',
            url: '/coordinatorqa',
            icon: PencilFill,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeeCoOrdinatorQAMenu),
        }, */
        {
            keyName: 'pending',
            text: 'Pending Panel',
            url: '/pending',
            icon: HourglassSplit,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeePendingPanelAssignmentMenu),
        },
        {
            keyName: 'ratify',
            text: 'To Ratify',
            url: '/ratify',
            icon: HourglassSplit,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeeRatifyMenu),
        },
        {
            keyName: 'assess',
            text: 'To Assess',
            url: '/assess',
            icon: HourglassSplit,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeeToAssessMenu),
        },
        {
            keyName: 'all',
            text: 'All Applications',
            url: '/all',
            icon: DatabaseFillCheck,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeePanelHistoryAssignmentMenu),
        },
        /* {
            keyName: 'test',
            text: 'Table Test',
            url: '/testy',
            icon: DatabaseFillCheck,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeePanelHistoryAssignmentMenu),
        }, */
        {
            keyName: 'history',
            text: 'History',
            url: '/history',
            icon: DatabaseFillCheck,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeePanelHistoryAssignmentMenu),
        },
        {
            keyName: 'dashboard',
            text: 'Dashboard',
            url: '/dashboard',
            icon: PieChartFill,
            rolePermissionsOnly: true,
            enabled: hasRolePermission(MenuPermissions.canSeeEHCPDashboardMenu),
        },
    ];

    const menuItems = (items) =>
    {
        const validItems = userMenuItems(user_type, hasRole, items);

        const groups = performGrouping(validItems);

        return <SidebarMenuRenderer groups={groups} />
    }

    return (
        <div className='sidebar-menu'>
            <Nav className="flex-column pt-2">
                <p key='title' className="sidebar-title"></p>
                {menuItems(menuItemList)}
            </Nav>
        </div>
    )
}

export default SidebarMenu;